import { useEffect, useState } from 'react'

import { pageSize as defaultPageSize } from 'app/application/constants'
import { Paging } from 'app/common/types'

import { List, ListProps, PageControls } from 'components'

interface PagedListProps<T> extends ListProps<T> {
  pageSize?: number
}

const getInitialPaging = <T,>(data: T[], pageSize: number) => ({
  page: 1,
  pageSize,
  totalPages: Math.ceil(data.length / pageSize),
})

const PagedList = <T,>({ data, pageSize = defaultPageSize, ...listProps }: PagedListProps<T>) => {
  const [paging, setPaging] = useState<Paging>(getInitialPaging(data, pageSize))

  useEffect(() => setPaging(getInitialPaging(data, pageSize)), [data, pageSize])

  return (
    <>
      <List
        data={data.slice((paging.page - 1) * paging.pageSize, paging.page * paging.pageSize)}
        {...listProps}
      />
      <PageControls
        currentPage={paging.page}
        onPageChange={(page) => setPaging((prev) => ({ ...prev, page }))}
        totalPages={paging.totalPages}
      />
    </>
  )
}

export default PagedList
